import {
    CREATEGATEWAYMAPPING_SUCCESS,
    CREATEGATEWAYMAPPING_FAILED,
    RESET_CREATEGATEWAYMAPPING,
    LOADING_CREATEGATEWAYMAPPING,
    NETWORK_ERROR_CREATEGATEWAYMAPPING,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_CREATEGATEWAYMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case CREATEGATEWAYMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case CREATEGATEWAYMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_CREATEGATEWAYMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_CREATEGATEWAYMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
